import { Component, Input } from '@angular/core';
import { Task } from '../../models/task';

@Component({
  selector: 'app-task-status',
  templateUrl: './task-status.component.html'
})
export class TaskStatusComponent {
  @Input() task: Task | undefined;

  constructor() {}

  get name() {
    if (this.task?.shortname) {
      const localize = $localize;
      let id = this.task.shortname;

      let match = localize(<any>{ '0': `:@@${id}:${id}`, raw: [':'] });
      if (match === id) {
        id = id.toUpperCase();
        match = localize(<any>{ '0': `:@@${id}:${id}`, raw: [':'] });

        if (match === id) {
          id = id.toLowerCase();
          match = localize(<any>{ '0': `:@@${id}:${id}`, raw: [':'] });
        }
      }

      return match;
    }

    return $localize`:@@none:none`;
  }

  get labelType() {
    if (!this.task) {
      return '';
    }
    switch (this.task.status) {
      case 'filepending':
        return 'label-info';
      case 'filereject':
        return 'label-danger';
      case 'filedecline':
        return 'label-warning';
      case 'filevalidated':
        return 'label-success';
      default:
        return 'label-default';
    }
  }
}
